var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5241 10.5449C9.13317 11.1164 5.20132 17.124 5.75423 20.4048C6.00325 21.8824 7.29684 22.5722 9.21543 22.2489C11.301 21.8974 12.4991 20.6035 14.1718 20.3216C15.8589 20.0373 17.4188 20.8664 19.486 20.518C21.4046 20.1947 22.4006 19.119 22.1516 17.6414C21.5987 14.3606 15.915 9.97342 12.5241 10.5449ZM6.14504 11.0709C5.45371 9.67872 3.92544 8.95922 2.73163 9.46346C1.53782 9.96769 1.13071 11.5049 1.82204 12.8971C2.51337 14.2893 4.04164 15.0088 5.23545 14.5045C6.42926 14.0003 6.83637 12.4631 6.14504 11.0709ZM9.61445 9.58142C10.8776 9.01413 11.2403 7.13299 10.4249 5.37988C9.60953 3.62676 7.92465 2.66588 6.66154 3.23317C5.39843 3.80046 5.03567 5.6816 5.85106 7.43472C6.66646 9.18784 8.35184 10.1491 9.61445 9.58142ZM21.4209 6.31422C20.1278 6.2291 18.9201 7.40967 18.7229 8.95161C18.526 10.4935 19.4145 11.8124 20.7076 11.8975C22.0007 11.9826 23.2083 10.802 23.4056 9.26009C23.6025 7.71823 22.714 6.39933 21.4209 6.31422ZM14.9573 8.68101C16.3365 8.80298 17.6134 7.34296 17.8092 5.41943C18.005 3.4959 17.0458 1.83799 15.6664 1.71559C14.2871 1.59319 13.0103 3.05363 12.8145 4.97716C12.6187 6.90069 13.578 8.55903 14.9573 8.68101Z",
    fill: "#1D5D9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.ec869fa82ad2fa97826ca095c9560714.svg";
export { ForwardRef as ReactComponent };